exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".TimeoutScreen__Note {\n  margin-bottom: 8px; }\n  .TimeoutScreen__Note strong {\n    margin: 0 2px; }\n\n.TimeoutScreen__Button {\n  float: right;\n  margin-left: 12px; }\n", ""]);

// exports
